import { AppShellContents } from '@/components/layout/AppShell';
import { TopBar } from '@/components/topBar/TopBar';
import { useTeamDashboardNavigation } from '@/hooks/navigation/useTeamDashboardNavigation';
import { Card, Status, Typography } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const NotFoundCard = () => {
  const { t } = useTranslation('general', { keyPrefix: 'notFound' });
  const teamDashboardRoute = useTeamDashboardNavigation();

  return (
    <div className="w-full h-full p-2">
      <Card>
        <Status
          type="error"
          title={t('title')}
          buttonProps={{
            as: Link,
            children: t('buttonLink'),
            to: teamDashboardRoute,
            size: 'small',
            variant: 'secondary',
          }}
        >
          <Typography variant="bodyRegular">
            {t('descriptionText')}
            <a className="underline" href="mailto:support@statsbomb.com">
              {t('descriptionContactText')}
            </a>
          </Typography>
        </Status>
      </Card>
    </div>
  );
};

export const NotFound = () => (
  <AppShellContents topBar={<TopBar />}>
    <NotFoundCard />
  </AppShellContents>
);
